import { DATE_FE_FORMAT_FULL } from '@/constants';
import { Dayts } from '@/utils/Dayts';
import Form from '@/common/Form';
import { QuestionnaireAttemptOverallResultEnum } from '@/models/gen/graphql';
import { ReactElement } from 'react';
import { CompleteEvaluationWizardTypes as Types } from '@/pages/Users/components/CompleteEvaluationWizard/types';
import { titleCase } from '@/utils';

export type Step2Props = {
  driverName: string;
  driverId?: string;
  startDate?: string | null;
  trainerName?: string;
  type?: string;
};

const formatDate = (value?: string | null): string => (value ? new Dayts(value).format(DATE_FE_FORMAT_FULL) : '—');

const Step2 = ({ driverName, driverId, startDate, trainerName, type }: Step2Props): ReactElement => (
  <div className="CompleteEvaluationWizard-Step">
    <div className="CompleteEvaluationWizard-SectionHeader">
      <i className="sv sv-checkmark-circle CompleteEvaluationWizard-SectionIcon CompleteEvaluationWizard-SectionIcon-Completion" />
      <div>
        <h5>Evaluation Completion</h5>
        <p>Review and submit the evaluation report</p>
      </div>
    </div>

    <div className="CompleteEvaluationWizard-Summary input-shadow">
      <p className="CompleteEvaluationWizard-Label">Evaluation Summary</p>
      <div className="CompleteEvaluationWizard-Summary-Row">
        <span>
          <span className="CompleteEvaluationWizard-Summary-Key">Driver:</span>
          <strong className="fw-semibold">{driverName}</strong>
        </span>
        <span>
          <span className="CompleteEvaluationWizard-Summary-Key">Driver ID:</span>
          <strong className="fw-semibold">{driverId || '—'}</strong>
        </span>
        <span>
          <span className="CompleteEvaluationWizard-Summary-Key">Start Date:</span>
          <strong className="fw-semibold">{formatDate(startDate)}</strong>
        </span>
        <span>
          <span className="CompleteEvaluationWizard-Summary-Key">Trainer:</span>
          <strong className="fw-semibold">{trainerName || '—'}</strong>
        </span>
      </div>
      <div className="CompleteEvaluationWizard-Summary-Row">
        <Form.Watch name="overallResult">
          {([overallResult]: QuestionnaireAttemptOverallResultEnum[]): ReactElement => (
            <span>
              <span className="CompleteEvaluationWizard-Summary-Key">Result:</span>
              <strong className="fw-semibold">{overallResult ? Types.OverallResultLabel[overallResult] : '—'}</strong>
            </span>
          )}
        </Form.Watch>
        <span>
          <span className="CompleteEvaluationWizard-Summary-Key">Type:</span>
          <strong className="fw-semibold">{type ? titleCase(type) : '—'}</strong>
        </span>
        <span>
          <span className="CompleteEvaluationWizard-Summary-Key">Completion Date:</span>
          <strong className="fw-semibold">{formatDate(new Date().toISOString())}</strong>
        </span>
      </div>
    </div>

    <p className="CompleteEvaluationWizard-Certification">
      By submitting, you certify that the information provided is accurate and complete.
    </p>

    <div className="CompleteEvaluationWizard-Notice">
      <p className="CompleteEvaluationWizard-Label">Important</p>
      <p>
        This evaluation will be immediately added to the driver&apos;s record and may impact their operational readiness status and
        assignment eligibility.
      </p>
    </div>
  </div>
);

export default Step2;
